<script>
export default {
  name: 'HeartsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8008 9.91016C17.6708 9.91016 16.6608 10.4602 16.0308 11.3002C15.4008 10.4602 14.3908 9.91016 13.2608 9.91016C11.3508 9.91016 9.80078 11.4702 9.80078 13.3902C9.80078 14.1302 9.92078 14.8202 10.1208 15.4502C11.1008 18.5602 14.1408 20.4302 15.6408 20.9402C15.8508 21.0102 16.2008 21.0102 16.4108 20.9402C17.9108 20.4302 20.9508 18.5702 21.9308 15.4502C22.1408 14.8102 22.2508 14.1302 22.2508 13.3902C22.2608 11.4702 20.7108 9.91016 18.8008 9.91016Z"
      :fill="color"
    />
    <path
      d="M20.75 8.33961C20.75 8.56961 20.52 8.71961 20.3 8.65961C18.95 8.30961 17.47 8.59961 16.35 9.39961C16.13 9.55961 15.83 9.55961 15.62 9.39961C14.83 8.81961 13.87 8.49961 12.86 8.49961C10.28 8.49961 8.18 10.6096 8.18 13.2096C8.18 16.0296 9.53 18.1396 10.89 19.5496C10.96 19.6196 10.9 19.7396 10.81 19.6996C8.08 18.7696 2 14.9096 2 8.33961C2 5.43961 4.33 3.09961 7.21 3.09961C8.92 3.09961 10.43 3.91961 11.38 5.18961C12.34 3.91961 13.85 3.09961 15.55 3.09961C18.42 3.09961 20.75 5.43961 20.75 8.33961Z"
      :fill="color"
    />
  </svg>
</template>
